import React from "react";

const Parameter = (props) => {
  return <div className='parameterDiv'>
  
    <label htmlFor={props.id} id={props.id} className={`${props.checked ? 'label-checked' : 'label-unchecked'}`} onClick={props.handleParamChange}>{props.name}</label>
    <input type="checkbox" id={props.id} checked={props.checked} onChange={props.handleParamChange}/>
    </div>;
}

export default Parameter;
